// La vista de la tabla de precios que puede ver CUALQUIER vendedor (sin costos ni piso, ADENDA A0b 11-oct): precios por
// tamaño, tope de descuento sin el OK de Diego y el catálogo de adicionales con su precio sugerido. Se pide una vez por
// sesión de la pantalla y se reusa (cambia solo cuando Diego guarda otra tabla; recargar la página la vuelve a pedir).
import { useEffect, useState } from 'react';
import type { VistaPrecios } from '@cotizador/compartido';
import { api } from '../api/consultas.ts';

let enCurso: Promise<VistaPrecios> | null = null;

export function pedirVistaPrecios(): Promise<VistaPrecios> {
  enCurso ??= api.precios().then((r) => r.vista);
  enCurso.catch(() => {
    enCurso = null; // un fallo de red no se queda guardado
  });
  return enCurso;
}

/** Solo para pruebas: olvida la vista guardada. */
export function olvidarVistaPrecios(): void {
  enCurso = null;
}

export function usarVistaPrecios(): { vista: VistaPrecios | null; error: unknown } {
  const [vista, setVista] = useState<VistaPrecios | null>(null);
  const [error, setError] = useState<unknown>(null);
  useEffect(() => {
    let vivo = true;
    pedirVistaPrecios()
      .then((v) => vivo && setVista(v))
      .catch((e: unknown) => vivo && setError(e));
    return () => {
      vivo = false;
    };
  }, []);
  return { vista, error };
}
